// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hi4Yqlteu8qJiv {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex-basis: 272px;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: start;
  justify-content: space-between;
  width: 272px;
  max-height: 100%;
  padding-bottom: var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--accent-background, var(--tr-background-list));
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--accent-text, var(--ds-text-subtle, #44546f));
  vertical-align: top;
  white-space: normal;
  scroll-margin: 8px;
  padding-bottom: var(--ds-space-0, 0);
  border-radius: var(--ds-border-radius-300, 10px);
  background: linear-gradient(98deg, var(--ds-background-brand-bold, #0c66e4) 0%, var(--ds-background-accent-blue-subtle, #579dff) 97.25%);
}
@media only screen and (max-width: 750px) {
  .Hi4Yqlteu8qJiv {
    scroll-snap-align: center;
  }
}
@media print {
  .Hi4Yqlteu8qJiv {
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    margin-bottom: 16px;
  }
}
.Hi4Yqlteu8qJiv.nIllwleHUzRJSc {
  flex-basis: auto;
  width: auto;
  max-width: fit-content;
  padding-bottom: var(--ds-space-0, 0);
}
.Hi4Yqlteu8qJiv.G8J1RABG7pnLLx {
  outline: 2px solid var(--ds-border-focused, #388bff);
}
.mac .Hi4Yqlteu8qJiv.G8J1RABG7pnLLx {
  outline-color: -webkit-focus-ring-color;
}
.mac.firefox .Hi4Yqlteu8qJiv.G8J1RABG7pnLLx {
  outline-color: AccentColor;
}
.Hi4Yqlteu8qJiv.cHKzVjdqSSm6VM {
  opacity: 0.4;
}
.nGOLXdDrISzSJJ {
  display: flex;
  align-items: center;
  padding: var(--ds-space-100, 8px);
}
.l607yRr6rYQzsQ {
  padding-bottom: var(--ds-space-075, 6px);
  border-top-left-radius: var(--ds-border-radius-300, 12px);
  border-top-right-radius: var(--ds-border-radius-300, 12px);
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  background-color: var(--accent-background, var(--tr-background-list));
  padding-bottom: var(--ds-space-200, 16px);
  border-radius: inherit;
}
.l607yRr6rYQzsQ.nIllwleHUzRJSc:hover {
  background-color: var(--ds-background-accent-gray-subtlest-hovered, #dcdfe4);
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.l607yRr6rYQzsQ.nIllwleHUzRJSc:active {
  background-color: var(--ds-background-accent-gray-subtlest-pressed, #b3b9c4);
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.l607yRr6rYQzsQ.nIllwleHUzRJSc {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: revert;
  padding: var(--ds-space-150, 12px) var(--ds-space-050, 4px) var(--ds-space-200, 16px);
  overflow: hidden;
  border-radius: inherit;
  cursor: pointer;
  writing-mode: vertical-lr;
}
.U6FfzY1zsua8bB {
  padding: var(--ds-space-200, 14px) var(--ds-space-200, 16px) var(--ds-space-150, 12px) var(--ds-space-250, 20px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 20px;
}
.U6FfzY1zsua8bB.nIllwleHUzRJSc {
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-050, 4px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.EbX3HmfNLMVDmn {
  display: flex;
  align-items: center;
  padding: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-100, 8px);
  font-weight: var(--ds-font-weight-medium, 500);
}
.RcEg_uVsu7kzFJ {
  margin-right: var(--ds-space-050, 4px);
  padding: var(--ds-space-050, 4px);
  color: var(--ds-icon, #44546f);
}
.YpOLRTMjGbd0bq {
  display: flex;
  z-index: 1;
  flex: 1 1 auto;
  flex-direction: column;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
  padding: var(--ds-space-050, 4px);
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
  row-gap: 8px;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translate3d(0, 0, 0);
  scrollbar-color: var(--ds-background-neutral-hovered, #091e4224) var(--ds-background-neutral, #091e420f);
  scrollbar-width: thin;
}
.YpOLRTMjGbd0bq.qnMpQeanpFNkKo {
  row-gap: var(--ds-space-0, 0);
  margin-top: var(--ds-space-negative-050, -4px);
}
[data-drag-preview] .YpOLRTMjGbd0bq {
  /* stylelint-disable-next-line declaration-no-important */
  overflow-y: hidden !important;
}
.YpOLRTMjGbd0bq[hidden] {
  display: none;
}
.YpOLRTMjGbd0bq::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.YpOLRTMjGbd0bq::-webkit-scrollbar-button:start:decrement,
.YpOLRTMjGbd0bq::-webkit-scrollbar-button:end:increment {
  display: none;
  background: transparent;
}
.YpOLRTMjGbd0bq::-webkit-scrollbar-track-piece {
  background: var(--ds-background-neutral, #091e420f);
}
.YpOLRTMjGbd0bq::-webkit-scrollbar-track-piece:vertical:start {
  border-radius: var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px) 0 0;
}
.YpOLRTMjGbd0bq::-webkit-scrollbar-track-piece:vertical:end {
  border-radius: 0 0 var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px);
}
.YpOLRTMjGbd0bq::-webkit-scrollbar-track-piece:horizontal:start {
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
}
.YpOLRTMjGbd0bq::-webkit-scrollbar-track-piece:horizontal:end {
  border-radius: 0 var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px) 0;
}
.YpOLRTMjGbd0bq::-webkit-scrollbar-thumb:vertical,
.YpOLRTMjGbd0bq::-webkit-scrollbar-thumb:horizontal {
  display: block;
  height: 48px;
  border-radius: var(--ds-border-radius-100, 4px);
  background: var(--ds-background-neutral-hovered, #091e4224);
}
.YpOLRTMjGbd0bq::-webkit-scrollbar-button:end {
  display: block;
  width: 4px;
  height: 4px;
}
@-moz-document url-prefix() {
  .YpOLRTMjGbd0bq {
    margin-right: var(--ds-space-0, 0);
    padding-right: var(--ds-space-100, 8px);
  }
}
.nGOLXdDrISzSJJ {
  display: flex;
  align-items: center;
  height: 24px;
  padding: var(--ds-space-100, 8px);
  color: var(--ds-text-inverse, #ffffff);
}
.uz3lLyp_mRmZtG {
  box-sizing: border-box;
  height: 24px;
  padding: var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-200, 6px);
  background: var(--ds-icon-inverse, #ffffff);
}
.uz3lLyp_mRmZtG span {
  width: 16px;
  height: 16px;
}
.jwFXs273ZLdP5d {
  padding: var(--ds-space-0, 0) var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-100, 8px);
  font-size: 12px;
  font-weight: var(--ds-font-weight-medium, 500);
}
`, ""]);
// Exports
export var skeletonWrapper = `Hi4Yqlteu8qJiv`;
export var collapsed = `nIllwleHUzRJSc`;
export var dropTarget = `G8J1RABG7pnLLx`;
export var isDragging = `cHKzVjdqSSm6VM`;
export var skeletonJiraHeader = `nGOLXdDrISzSJJ`;
export var skeletonList = `l607yRr6rYQzsQ`;
export var skeletonListName = `U6FfzY1zsua8bB`;
export var skeletonSyncButton = `EbX3HmfNLMVDmn`;
export var skeletonRefreshIcon = `RcEg_uVsu7kzFJ`;
export var skeletonCards = `YpOLRTMjGbd0bq`;
export var hoverGapEnabled = `qnMpQeanpFNkKo`;
export var skeletonJiraIconWrapper = `uz3lLyp_mRmZtG`;
export var skeletonSyncedFrom = `jwFXs273ZLdP5d`;
export default ___CSS_LOADER_EXPORT___;
